<afoone-breadcrumb></afoone-breadcrumb>

<h3>{{ 'LOGS.TITLE' | translate }}</h3>

<div class="toolbar">
  <select [(ngModel)]="selectedFile">
    <option *ngFor="let file of files" [value]="file.name">
      {{ file.name }} ({{ file.size }} B)
    </option>
  </select>

  <button pButton type="button" (click)="refreshFiles()" [label]="'LOGS.REFRESH' | translate"></button>
  <button pButton type="button" (click)="downloadSelected()" [label]="'LOGS.DOWNLOAD' | translate" [disabled]="!selectedFile"></button>
  <button pButton type="button" (click)="readNow()" [label]="'LOGS.READ' | translate" [disabled]="!selectedFile || !!selected?.isArchive"></button>
  <button pButton type="button" (click)="startTail()" [label]="'LOGS.TAIL_START' | translate" [disabled]="!selectedFile || !!selected?.isArchive || tailMode"></button>
  <button pButton type="button" (click)="stopTail()" [label]="'LOGS.TAIL_STOP' | translate" [disabled]="!tailMode"></button>
</div>

<div class="toolbar">
  <label>{{ 'LOGS.TAIL_LINES' | translate }}</label>
  <input type="number" min="10" max="2000" [(ngModel)]="lines" />
  <label>{{ 'LOGS.READ_BYTES' | translate }}</label>
  <input type="number" min="1024" max="1048576" [(ngModel)]="readBytes" />
</div>

<p *ngIf="selected?.isArchive" class="info">{{ 'LOGS.ARCHIVE_ONLY' | translate }}</p>
<p *ngIf="error" class="error">{{ error | translate }}</p>

<pre class="terminal">{{ content }}</pre>
